import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AppProvider, useApp } from "./lib/ctx";
import { Header, BottomNav, Footer } from "./components/Chrome";
import { Toaster } from "sonner";
import { useEffect, useState } from "react";
import { api } from "./lib/api";

import Home from "./pages/Home";
import Story from "./pages/Story";
import Category from "./pages/Category";
import {
  Search, Explainers, SixtySeconds, Categories, Saved,
  Videos, LiveBlogList, LiveBlogDetail, Quiz, Newsletter, Tip, Advertise, About, NotFound,
} from "./pages/Pages";
import { AdminLogin, AdminRoutes } from "./pages/Admin";

const Shell = ({ children }) => {
  const [ticker, setTicker] = useState([]);
  useEffect(() => { api.get("/ticker").then(r => setTicker(r.data)).catch(() => {}); }, []);
  return (
    <div className="min-h-screen flex flex-col">
      <Header ticker={ticker} />
      <main className="flex-1 pb-20 md:pb-0">{children}</main>
      <Footer />
      <BottomNav />
    </div>
  );
};

const WithShell = ({ el }) => <Shell>{el}</Shell>;

function AppInner() {
  const { lang } = useApp();
  const loc = useLocation();
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  useEffect(() => { window.scrollTo(0, 0); }, [loc.pathname]);
  return (
    <>
      <Toaster richColors position="top-center" />
      <Routes>
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/" element={<WithShell el={<Home />} />} />
        <Route path="/story/:slug" element={<WithShell el={<Story />} />} />
        <Route path="/category/:slug" element={<WithShell el={<Category />} />} />
        <Route path="/categories" element={<WithShell el={<Categories />} />} />
        <Route path="/sixty-seconds" element={<WithShell el={<SixtySeconds />} />} />
        <Route path="/explainers" element={<WithShell el={<Explainers />} />} />
        <Route path="/videos" element={<WithShell el={<Videos />} />} />
        <Route path="/live-blogs" element={<WithShell el={<LiveBlogList />} />} />
        <Route path="/live/:slug" element={<WithShell el={<LiveBlogDetail />} />} />
        <Route path="/quiz" element={<WithShell el={<Quiz />} />} />
        <Route path="/search" element={<WithShell el={<Search />} />} />
        <Route path="/saved" element={<WithShell el={<Saved />} />} />
        <Route path="/newsletter" element={<WithShell el={<Newsletter />} />} />
        <Route path="/tip" element={<WithShell el={<Tip />} />} />
        <Route path="/advertise" element={<WithShell el={<Advertise />} />} />
        <Route path="/about" element={<WithShell el={<About />} />} />
        <Route path="*" element={<WithShell el={<NotFound />} />} />
      </Routes>
    </>
  );
}

export default function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppInner />
      </BrowserRouter>
    </AppProvider>
  );
}
